export enum NTHMonth {
    Janvier = "Janvier",
    Fevrier = "Février",
    Mars = "Mars",
    Avril = "Avril",
    Mai = "Mai",
    Juin = "Juin",
    Juillet = "Juillet",
    Aout = "Août",
    Septembre = "Septembre",
    Octobre = "Octobre",
    Novembre = "Novembre",
    Decembre = "Décembre"
  }
  
  export function stringifyMonths(months: NTHMonth[]): string[] {
    const response = [];
    months.forEach(month => {
      switch (month) {
        case NTHMonth.Janvier:
          response.push('Janvier');
          break;
        case NTHMonth.Fevrier:
          response.push('Février');
          break;
        case NTHMonth.Mars:
          response.push('Mars');
          break;
        case NTHMonth.Avril:
          response.push('Avril');
          break;
        case NTHMonth.Mai:
          response.push('Mai');
          break;
        case NTHMonth.Juin:
          response.push('Juin');
          break;
        case NTHMonth.Juillet:
          response.push('Juillet');
          break;
        case NTHMonth.Aout:
          response.push('Août');
          break;
        case NTHMonth.Septembre:
          response.push('Septembre');
          break;
        case NTHMonth.Octobre:
          response.push('Octobre');
          break;
        case NTHMonth.Novembre:
          response.push('Novembre');
          break;
        case NTHMonth.Decembre:
          response.push('Décembre');
          break;
      }
    });
    return response;
  }

  export function getMonth(num: number): string {
    let lbl = "";
    switch (num)
    {
        case 1: lbl = NTHMonth.Janvier; break;
        case 2: lbl = NTHMonth.Fevrier; break;
        case 3: lbl = NTHMonth.Mars; break;
        case 4: lbl = NTHMonth.Avril; break;
        case 5: lbl = NTHMonth.Mai; break;
        case 6: lbl = NTHMonth.Juin; break;
        case 7: lbl = NTHMonth.Juillet; break;
        case 8: lbl = NTHMonth.Aout; break;
        case 9: lbl = NTHMonth.Septembre; break;
        case 10: lbl = NTHMonth.Octobre; break;
        case 11: lbl = NTHMonth.Novembre; break;
        case 12: lbl = NTHMonth.Decembre; break;
        default: lbl = ""; break;
    }
    return lbl;
  }

  export function getNumMonth(month: string): number {
    switch (month)
    {
        case NTHMonth.Janvier: return 1 ;
        case NTHMonth.Fevrier: return 2;
        case NTHMonth.Mars: return 3;
        case NTHMonth.Avril: return 4;
        case NTHMonth.Mai: return 5;
        case NTHMonth.Juin: return 6;
        case NTHMonth.Juillet: return 7;
        case NTHMonth.Aout: return 8;
        case NTHMonth.Septembre: return 9;
        case NTHMonth.Octobre: return 10;
        case NTHMonth.Novembre: return 11;
        case NTHMonth.Decembre: return 12;
    }
  }
  